import { FC } from "react";
import { Heading } from "../../../typography";
import { useThemeStore } from "../../../../stores";
import { ActivityRendererType } from "../../types";
import { ActivityTitleProps } from "./types";

const ActivityTitle: FC<ActivityTitleProps> = ({ type, children = "" }) => {
  const theme = useThemeStore((state) => state.theme);
  const COLOR =
    type === ActivityRendererType.Big ? theme.textOnOverlay : theme.textOnBg;
  return (
    <Heading textStyles={{ marginTop: 4 }} color={COLOR} size={12}>
      {children}
    </Heading>
  );
};

export default ActivityTitle;
